/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import { createMuiTheme } from "@material-ui/core/styles";
import { csrAppMuiThemeConfig } from "./shared-theme";

const theme = createMuiTheme(csrAppMuiThemeConfig);

export default theme;
